import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import LifecycleStagesAPI from '../../api/lifecycleStages';

export const state = {
  records: [],
  settings: {
    enabled: true,
  },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getStages(_state) {
    return _state.records;
  },
  getLifecycleStages(_state) {
    return _state.records.filter(stage => stage.category === 'lifecycle_stage');
  },
  getLostStages(_state) {
    return _state.records.filter(stage => stage.category === 'lost_stage');
  },
  getSettings(_state) {
    return _state.settings;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getStageById: _state => id => {
    return _state.records.find(stage => stage.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getLifecycleStages({ commit }) {
    commit(types.SET_LIFECYCLE_STAGE_UI_FLAG, { isFetching: true });
    try {
      const response = await LifecycleStagesAPI.get();
      commit(types.SET_LIFECYCLE_STAGES, response.data.payload);
      commit(types.SET_LIFECYCLE_STAGE_SETTINGS, response.data.settings);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_LIFECYCLE_STAGE_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createLifecycleStage({ commit }, stage) {
    commit(types.SET_LIFECYCLE_STAGE_UI_FLAG, { isCreating: true });
    try {
      const response = await LifecycleStagesAPI.create(stage);
      commit(types.ADD_LIFECYCLE_STAGE, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LIFECYCLE_STAGE_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateLifecycleStage({ commit }, { id, ...stage }) {
    commit(types.SET_LIFECYCLE_STAGE_UI_FLAG, { isUpdating: true });
    try {
      const response = await LifecycleStagesAPI.update(id, stage);
      commit(types.EDIT_LIFECYCLE_STAGE, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LIFECYCLE_STAGE_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteLifecycleStage({ commit }, id) {
    commit(types.SET_LIFECYCLE_STAGE_UI_FLAG, { isDeleting: true });
    try {
      await LifecycleStagesAPI.delete(id);
      commit(types.DELETE_LIFECYCLE_STAGE, id);
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LIFECYCLE_STAGE_UI_FLAG, { isDeleting: false });
    }
  },

  updateSettings: async function updateLifecycleStageSettings(
    { commit },
    settings
  ) {
    commit(types.SET_LIFECYCLE_STAGE_UI_FLAG, { isUpdating: true });
    try {
      const response = await LifecycleStagesAPI.updateSettings({ settings });
      commit(types.SET_LIFECYCLE_STAGE_SETTINGS, response.data.settings);
      return response.data.settings;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LIFECYCLE_STAGE_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_LIFECYCLE_STAGE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_LIFECYCLE_STAGE_SETTINGS](_state, data) {
    _state.settings = {
      ..._state.settings,
      ...data,
    };
  },
  [types.SET_LIFECYCLE_STAGES]: MutationHelpers.set,
  [types.ADD_LIFECYCLE_STAGE]: MutationHelpers.create,
  [types.EDIT_LIFECYCLE_STAGE]: MutationHelpers.update,
  [types.DELETE_LIFECYCLE_STAGE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
